<template>
  <label class="radio">
    <span class="radio__input">
      <input v-model="model" type="radio" v-bind="attrs" :value="nativeValue" v-on="listeners" />
      <span class="radio__control"></span>
    </span>
    <span class="radio__label"><slot></slot></span>
  </label>
</template>

<script>
export default {
  name: 'TRadio',

  props: {
    nativeValue: {
      type: [String, Boolean, Number, null],
      default: null
    }
  },

  computed: {
    listeners() {
      const { input, ...rest } = this.$listeners
      return rest
    },

    attrs() {
      const { nativeValue, ...rest } = this.$attrs

      return rest
    },

    model: {
      get() {
        return this.value
      },

      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
